import React, { useEffect, useRef, useState } from 'react';
import './Section_1.css';
import { FaLinkedinIn, FaGithub } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';

export function Section1() {
  const textRef = useRef(null);
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    // Fetch profile data dynamically
    const fetchProfile = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/profile`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setProfile(data.profile);
      } catch (error) {
        console.error('Error fetching profile data:', error);
      }
    };

    fetchProfile();
  }, []);

  useEffect(() => {
    if (!profile) return;

    const texts = [
      "Frontend Developer",
      "Backend Developer",
      "ML Expert",
      "DL Specialist",
      "Cybersecurity Enthusiast"
    ];
    let index = 0;
    let charIndex = 1;
    let currentText = texts[index].charAt(0);
    let isDeleting = false;

    function type() {
      if (textRef.current) {
        if (isDeleting) {
          currentText = texts[index].charAt(0) + texts[index].substring(1, charIndex - 1) + texts[(index + 1) % texts.length].charAt(1);
          charIndex--;
        } else {
          currentText = texts[index].charAt(0) + texts[index].substring(1, charIndex + 1);
          charIndex++;
        }

        textRef.current.innerHTML = `<span class="role-${index}">${currentText}</span>`;

        if (!isDeleting && charIndex === texts[index].length) {
          isDeleting = true;
          setTimeout(type, 2500);
        } else if (isDeleting && charIndex === 1) {
          isDeleting = false;
          index = (index + 1) % texts.length;
          setTimeout(type, 500);
        } else {
          setTimeout(type, isDeleting ? 50 : 100);
        }
      }
    }

    type();
  }, [profile]);

  if (!profile) {
    return <p>Loading...</p>;
  }

  return (
    <div className="hero">
      <div className="content">
        <p className="greeting">Hello, I'm</p>
        <h1>
          <span className="name">{profile.name}</span>
          <br /> <span className="role-container" ref={textRef}></span>
        </h1>
        <p className="description">{profile.bio}</p>
        <div className="buttons">
          {profile.resume_link && (
            <a
              href={profile.resume_link}
              className="btn secondary hire-me-btn btn-animated"
              target="_blank"
              rel="noopener noreferrer"
            >
              Resume
            </a>
          )}
        </div>
      </div>

      <div className="profile-social-container">
        <div className="profile">
          <img src={profile.profile_photo} alt="Profile" loading="lazy" />
        </div>

        <div className="socials">
          {profile.social_profiles.linkedin && (
            <a href={profile.social_profiles.linkedin} target="_blank" rel="noopener noreferrer" title="LinkedIn">
              <FaLinkedinIn />
            </a>
          )}
          {profile.social_profiles.github && (
            <a href={profile.social_profiles.github} target="_blank" rel="noopener noreferrer" title="GitHub">
              <FaGithub />
            </a>
          )}
          {profile.email && (
            <a href={`mailto:${profile.email}`} title="Email">
              <MdEmail />
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default Section1;
